import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment, { type Moment } from "moment";
import { useFormsContext } from "../context/formsContext";

type Props = {};

export const ProductionDateSelectorModal = ({}: Props) => {
	const {
		state: {},
		actions: { setNewInstanceProductionDate },
	} = useFormsContext();

	const [productionDate, setProductionDate] = useState<Moment>(moment());

	const handleDateChange = (datePicker: Moment | null) => {
		if (datePicker) {
			setProductionDate(datePicker);
			setNewInstanceProductionDate(datePicker.format("YYYY-MM-DD"));
		}
	};

	useEffect(() => {
		setProductionDate(moment());
	}, []);

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				format="MM/DD/YYYY"
				label="Datetime"
				value={productionDate}
				onChange={handleDateChange}
				slotProps={{
					textField: {
						sx: {
							minWidth: "100%",
							borderTopLeftRadius: 3,
							borderTopRightRadius: 3,
						},
					},
				}}
			/>
		</LocalizationProvider>
	);
};
